import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonFillComponent } from './button-fill.component';



@NgModule({
  declarations: [
    ButtonFillComponent
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    ButtonFillComponent
  ]
})
export class ButtonFillModule { }
